import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  buttonWrapper: {
    paddingBottom: pxToRem(30),
  },
  detailsHeader: {
    paddingLeft: pxToRem(13),
  },
  primaryBottomBorder: {
    borderBottom: `1px solid ${theme.palette.themePrimary}`,
  },
  editAdvanceGroup: {
    float: 'right',
    paddingTop: pxToRem(30),
  },
  subModule: {
    width: '100%',
  },
  subModuleHeader: {
    paddingTop: pxToRem(5),
    paddingBottom: pxToRem(5),
  },
  negativeAmount: {
    color: theme.palette.accentError,
  },
  downButton: {
    marginRight: pxToRem(14),
    background: `${theme.palette.neutralWhite} !important`,
  },
  upButton: {
    background: `${theme.palette.neutralWhite} !important`,
  },
  noBottomBorder: {
    borderBottom: `0px`,
    marginLeft: pxToRem(-10),
  },
  advanceGroupName: {
    color: theme.palette.neutralDark,
    fontWeight: 600,
    marginTop: pxToRem(12),
  },
  cardWrapper: {
    marginLeft: pxToRem(-10),
    marginRight: pxToRem(-10),
  },
});
